export const keyLocalStorage =
  'journeyListWaitingConfirmDeliveryDisplayAllowedAt';

export function getDisplayAllowedAt() {
  return window.localStorage.getItem(keyLocalStorage) || '';
}

export function setDateShowList() {
  const currentDate = new Date();
  const nextDay = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate() + 1,
    6,
  );

  window.localStorage.setItem(keyLocalStorage, nextDay.getTime().toString());
}

export function isAllowedShowList() {
  const displayAllowedAt = getDisplayAllowedAt();
  const displayAllowedNumber = parseInt(displayAllowedAt, 10);

  if (!displayAllowedAt) {
    return true;
  }

  if (
    !displayAllowedNumber ||
    new Date().getTime() >= new Date(displayAllowedNumber).getTime()
  ) {
    return true;
  }

  return false;
}
